import {
  BASIC_URL,
  // DOMAIN,
  LEGISLATOR_MANAGEMENT_MODULE,
  PROFILE_MANAGEMENT_MODULE,
  REGISTRATION_MODULE,
} from 'config/api-variables';
import { ContextTypes, ServiceTypes, StatusCodes } from 'config/global-enums';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import {
  // changeCookiesName,
  extendCookieExpiration,
  getDeviceDetails,
  getUserType,
  logoutClearLocal,
  resetDeviceDetails,
  setAuthKey,
} from 'utils/local-storage/user';

import { authenticationFormActions as actions } from '.';
import {
  handleErrorMessage,
  sagaSpecialRequestTemplate,
} from 'utils/tools/slice-actions';
import { request } from 'utils/request';
import { selectOfficeDetails, selectUserDetails } from './selectors';
import { uploadFileRequest } from 'modules/common/UploadMedia/uploadFileRequest';
// import { removeHttpHttpsWww } from 'utils/tools/data-transformers';

export function* phoneSubmit({ payload }) {
  const requestURL = REGISTRATION_MODULE + '/send-otp/';

  try {
    const response = yield call(request, requestURL, payload, false);
    if (response?.statusCode === StatusCodes.SUCCESS_CODE) {
      yield put(actions.authPhoneEnd());
    } else {
      yield call(
        handleErrorMessage,
        response?.message,
        actions,
        'phoneNumberError',
      );
    }
  } catch (err) {
    if (err?.response?.status === 404) {
      yield call(
        handleErrorMessage,
        'User not found!',
        actions,
        'phoneNumberError',
      );
    }
  }
}

export function* verifyOtp({ payload }) {
  const requestURL = REGISTRATION_MODULE + '/login/';

  try {
    const response = yield call(
      request,
      requestURL,
      payload,
      false,
      resetDeviceDetails(),
    );
    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      setAuthKey(response?.rows?.token);
      yield call(fetchProfile);
      yield put(actions.verifyOtpEnd());
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
    }
  } catch (err) {
    yield call(handleErrorMessage, 'OTP Invalid!', actions, 'authError');
  }
}

export function* verifySocialLogin({ payload }) {
  const requestURL = REGISTRATION_MODULE + '/social/login';

  try {
    const response = yield call(
      request,
      requestURL,
      payload,
      false,
      resetDeviceDetails(),
    );
    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      setAuthKey(response?.rows?.token);
      yield call(fetchProfile);
      yield put(actions.verifySocialLoginEnd());
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Unable to verify user! Please try again later',
      actions,
      'authError',
    );
  }
}

export function* fetchProfile() {
  const requestURL = PROFILE_MANAGEMENT_MODULE + '/profile/';

  try {
    const response = yield call(request, requestURL, { person_id: null });
    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      // Use this if need to redirect to the organisation domain
      // if (
      //   process.env.NODE_ENV !== 'development' &&
      //   removeHttpHttpsWww(window.location.hostname) !==
      //     response?.rows?.organisation_domain
      // ) {
      //   changeCookiesName(
      //     response?.rows?.organisation_domain,
      //     window.location.pathname,
      //   );
      // } else {
      //   yield all([
      //     put(actions.registerProfile(response?.rows)),
      //     put(
      //       actions.setUserOffice(
      //         response?.rows?.demo_organisation_details
      //           ? response?.rows?.demo_organisation_details
      //           : response?.rows?.organisation_offices?.[0],
      //       ),
      //     ),
      //   ]);
      //   extendCookieExpiration();
      // }
      const organisationOfficeId =
        response?.rows?.crm_contact_list?.length > 0 &&
        response?.rows?.crm_contact_list[0]?.organisation_office_id
          ? response?.rows?.crm_contact_list[0]?.organisation_office_id
          : response?.rows?.organisation_offices?.[0]?.id;

      const userOffice =
        response?.rows?.demo_organisation_details ||
        response?.rows?.organisation_offices?.[0] ||
        (response?.rows?.crm_contact_list?.length > 0 &&
        response?.rows?.crm_contact_list[0]?.organisation_office_id
          ? { id: response?.rows?.crm_contact_list[0]?.organisation_office_id }
          : null);

      console.log('organisationOfficeId simba', organisationOfficeId);
      console.log('userOffice simba', userOffice);

      yield all([
        put(actions.registerProfile(response?.rows)),
        put(actions.setOriginalOfficeId(organisationOfficeId)),
        put(actions.setUserOffice(userOffice)),
      ]);
      // yield all([
      //   put(actions.registerProfile(response?.rows)),
      //   put(
      //     actions.setOriginalOfficeId(
      //       response?.rows?.organisation_offices?.[0]?.id,
      //     ),
      //   ),
      //   put(
      //     actions.setUserOffice(
      //       response?.rows?.demo_organisation_details
      //         ? response?.rows?.demo_organisation_details
      //         : response?.rows?.organisation_offices?.[0],
      //     ),
      //   ),
      // ]);
      extendCookieExpiration();
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
      if (response?.status === 401) setTimeout(logoutClearLocal, 2300);
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Unable to fetch profile!',
      actions,
      'authError',
    );
  }
}

export function* personalDetailsRegister({ payload }) {
  const { userDetails } = yield select(selectUserDetails);

  const { image_url: image_path, ...personalDetails } = payload;

  const requestURL = PROFILE_MANAGEMENT_MODULE + '/profile/edit';

  try {
    const response = yield call(request, requestURL, personalDetails);

    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      const linkResponse = yield call(linkImageToProfile, {
        owner_type: ServiceTypes.PERSON,
        owner_id: userDetails?.id,
        image_type: ContextTypes.PROFILE,
        image_path,
        errorActionName: 'authError',
      });
      yield call(fetchProfile);
      if (linkResponse?.linkSuccess) yield put(actions.formSubmitSuccess());
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Failed to save personal details!',
      actions,
      'authError',
    );
  }
}

export function* manageCustomerOrgainsation({ payload }) {
  const requestURL =
    LEGISLATOR_MANAGEMENT_MODULE + '/organisation-customer/manage';

  try {
    const response = yield call(request, requestURL, {
      app_type: getUserType(),
      ...payload,
    });
    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      // const customerOrgResponseData = response.rows;
      yield put(actions.formSubmitSuccess());
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Failed to save customer orgainsation!',
      actions,
      'authError',
    );
  }
}

export function* registerOrganisation({ payload }) {
  const { userObject } = yield select(selectUserDetails);
  const { imageFile, ...restPayload } = payload;

  const requestURL = LEGISLATOR_MANAGEMENT_MODULE + '/user/register';

  try {
    const response = yield call(request, requestURL, {
      app_type: getUserType(),
      person_id: userObject?.id,
      account_type: getUserType().toLowerCase(),
      plan_id: 8,
      ...restPayload,
    });

    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      const legislationResponseData = response.rows;

      if (imageFile) {
        const imageResponse = yield call(
          uploadFileRequest,
          imageFile,
          ServiceTypes.ORGANISATION,
          legislationResponseData?.organisation_office_id,
          ContextTypes.PROFILE,
        );
        const imageData = imageResponse?.data;
        if (imageData?.statusCode === StatusCodes.SUCCESS_CODE) {
          const linkResponse = yield call(linkImageToProfile, {
            owner_type: ServiceTypes.ORGANISATION,
            owner_id: legislationResponseData?.organisation_office_id,
            image_type: ContextTypes.PROFILE,
            image_path: imageData?.rows?.file_thumbnail_url,
            errorActionName: 'authError',
          });
          if (linkResponse?.linkSuccess) yield put(actions.formSubmitSuccess());
        } else {
          yield call(
            handleErrorMessage,
            imageData?.message,
            actions,
            'authError',
          );
        }
      } else {
        yield put(actions.formSubmitSuccess());
      }
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Failed to save office details!',
      actions,
      'authError',
    );
  }
}

export function* linkImageToProfile({
  owner_type,
  owner_id,
  image_type,
  image_path,
  errorActionName,
}) {
  const requestURL = BASIC_URL + '/file/update/';

  const payload = {
    owner_type,
    owner_id,
    image_type,
    image_path,
  };

  try {
    const response = yield call(request, requestURL, payload);

    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      return { linkSuccess: true };
    } else {
      yield call(
        handleErrorMessage,
        response?.message,
        actions,
        errorActionName,
      );
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Problem updating image! Try after some time...',
      actions,
      errorActionName,
    );
  }
}

export function* logUserOut() {
  const requestURL = REGISTRATION_MODULE + '/logout/';

  try {
    const response = yield call(
      request,
      requestURL,
      {},
      true,
      getDeviceDetails() || {},
    );

    if (response.statusCode === StatusCodes.SUCCESS_CODE) {
      logoutClearLocal();
      yield put(actions.logoutEnd());
    } else {
      yield call(handleErrorMessage, response?.message, actions, 'authError');
    }
  } catch (err) {
    yield call(
      handleErrorMessage,
      'Problem logging out! Try after some time...',
      actions,
      'authError',
    );
  }
}

function* fetchOrganisationTechList({ payload }) {
  const { officeDetails } = yield select(selectOfficeDetails);

  yield call(
    sagaSpecialRequestTemplate,
    LEGISLATOR_MANAGEMENT_MODULE + '/website/tech/links/list',
    {
      organisation_office_id: officeDetails?.id,
      ...payload,
    },
    actions,
    'fetchPageActionEnd',
    'fetchPageActionError',
    'There was a problem changing the status!',
    false,
  );
}

/**
 * Root saga manages watcher lifecycle
 */
export function* authenticationFormSaga() {
  yield takeLatest(actions.authPhoneStart.type, phoneSubmit);
  yield takeLatest(actions.verifyOtpStart.type, verifyOtp);
  yield takeLatest(actions.verifySocialLoginStart.type, verifySocialLogin);
  yield takeLatest(actions.fetchProfileStart.type, fetchProfile);
  yield takeLatest(actions.registerPersonal.type, personalDetailsRegister);
  yield takeLatest(
    actions.manageCustomerOganisationStart.type,
    manageCustomerOrgainsation,
  );
  yield takeLatest(
    actions.registerOrganisationStart.type,
    registerOrganisation,
  );
  yield takeLatest(actions.logoutStart.type, logUserOut);
  yield takeLatest(
    actions.fetchOrganisationTechListStart.type,
    fetchOrganisationTechList,
  );
}
